import { NextResponse } from "next/server";
import type { NextRequest } from "next/server";

export function middleware(req: NextRequest) {
  const url = req.nextUrl.clone();
  const token = req.cookies.get(process.env.NEXT_PUBLIC_AUTH_COOKIE_NAME!)?.value;

  // If no token, redirect to login
  if (!token) {
    return NextResponse.redirect(new URL("/login", req.url));
  }

  // Force lowercase paths
  const lowercasedPath = url.pathname.toLowerCase();
  if (url.pathname !== lowercasedPath) {
    url.pathname = lowercasedPath;
    return NextResponse.redirect(url);
  }

  return NextResponse.next();
}

// ✅ Apply only to protected routes
export const config = {
  matcher: [
    "/dashboard/:path*",
    "/users/:path*",
    "/inventory/:path*",
    "/orders/:path*",
    "/(org)/:path*",
  ],
};